<template>
    <div class="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>
<script>
export default {
    name: 'Loader'
};
</script>
<style lang="scss">
    .loader {
        position: relative;
        display: block;
        width: 64px;
        height: 64px;
        margin: auto;

        &.overlay {
            position: absolute;
            display: block;
            top: 50%;
            left: 50%;
            width: 64px;
            height: 64px;
            transform: translate(-50%, -50%);
            z-index: 1;
        }

        div {
            display: block;
            position: absolute;
            width: 51px;
            height: 51px;
            margin: 6px;
            border: 6px solid $lazy-color;
            border-radius: 50%;
            animation: loader 1.2s ease-in-out infinite;
            border-color: $lazy-color transparent transparent transparent;

            &:nth-child(1) {
                animation-delay: -0.45s;
            }
            &:nth-child(2) {
                animation-delay: -0.3s;
            }
            &:nth-child(3) {
                animation-delay: -0.15s;
            }
        }

        @keyframes loader {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
</style>
